import { render } from "./StorefrontSavedAddresses.vue?vue&type=template&id=34110213"
import script from "./StorefrontSavedAddresses.vue?vue&type=script&lang=js"
export * from "./StorefrontSavedAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__